var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextT = function SvgIconTextT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 5.25a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-2H13v11.5h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V6.25H5.5v2a1 1 0 0 1-2 0z"
  })));
};
export default SvgIconTextT;